module.exports = __webpack_public_path__ + "img/ic_camp.ca89a06a.svg";